import { ADD_SALARY, UPDATE_SALARY, DELETE_SALARY, GET_SALARY } from "../type";
import { InsertData } from "../../Hooks/InsertData";
import { GetDataToken } from "../../Hooks/getAllData";
import { InsUpdateData } from "../../Hooks/UpdataData";
import DeleteData from "../../Hooks/DeleteData";

export function buildSalaryQuery(params = {}) {
  const searchParams = new URLSearchParams();
  const normalized = {
    From: params.from ?? params.From,
    To: params.to ?? params.To,
    SearchTerm: params.searchTerm ?? params.SearchTerm,
    PageNumber: params.pageNumber ?? params.PageNumber,
    PageSize: params.pageSize ?? params.PageSize,
  };

  Object.entries(normalized).forEach(([key, value]) => {
    if (value == null || String(value).trim() === "") return;
    searchParams.append(key, String(value).trim());
  });

  return searchParams.toString();
}

export const CreateSalaryAction = (data) => async (dispatch) => {
  try {
    const respons = await InsertData(`/api/Salary`, data);
    dispatch({
      type: ADD_SALARY,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: ADD_SALARY,
      payload: "Error" + e,
    });
  }
};

export const GetAllSalaryAction = (quary) => async (dispatch) => {
  try {
    const queryString =
      typeof quary === "string"
        ? buildSalaryQuery(Object.fromEntries(new URLSearchParams(quary)))
        : buildSalaryQuery(quary);
    const url = queryString ? `/api/Salary?${queryString}` : `/api/Salary`;
    const respons = await GetDataToken(url);
    dispatch({
      type: GET_SALARY,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: GET_SALARY,
      payload: "Error" + e,
    });
  }
};

export const UpdateSalaryAction = (body) => async (dispatch) => {
  try {
    const respons = await InsUpdateData(`/api/Salary`, body);
    dispatch({
      type: UPDATE_SALARY,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: UPDATE_SALARY,
      payload: "Error" + e,
    });
  }
};

export const DeleteSalaryAction = (Id) => async (dispatch) => {
  try {
    const respons = await DeleteData(`/api/Salary?id=${Id}`);
    dispatch({
      type: DELETE_SALARY,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: DELETE_SALARY,
      payload: "Error" + e,
    });
  }
};
